import { createRouter, createWebHistory } from 'vue-router'
import CatalogView from './views/CatalogView.vue'
import CustomizationReviewView from './views/CustomizationReviewView.vue'
import CustomDesignView from './views/CustomDesignView.vue'
import HomeView from './views/HomeView.vue'
import LoginView from './views/LoginView.vue'
import NotFoundView from './views/NotFoundView.vue'
import OrderDetailView from './views/OrderDetailView.vue'
import OrdersView from './views/OrdersView.vue'
import ProductDetailView from './views/ProductDetailView.vue'
import TrustView from './views/TrustView.vue'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to, _from, savedPosition) => {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 92 }
    return { top: 0 }
  },
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/trust', name: 'trust', component: TrustView },
    { path: '/custom-design', name: 'custom-design', component: CustomDesignView },
    { path: '/products', name: 'catalog', component: CatalogView },
    { path: '/products/:slug', name: 'product', component: ProductDetailView },
    {
      path: '/products/:slug/customization-review',
      name: 'customization-review',
      component: CustomizationReviewView,
    },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/orders', name: 'orders', component: OrdersView, meta: { requiresAuth: true } },
    {
      path: '/orders/:id',
      name: 'order-detail',
      component: OrderDetailView,
      meta: { requiresAuth: true },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
  ],
})

router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true
  try {
    const session = JSON.parse(localStorage.getItem('cabinet-customer-session') || '{}')
    if (session.customerId && session.phone && session.accessToken) return true
  } catch {
    localStorage.removeItem('cabinet-customer-session')
  }
  return {
    name: 'login',
    query: { redirect: to.fullPath },
  }
})
